var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusBlu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 7.822 7.636",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0089fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006bfb"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_311",
    "data-name": "Tracciato 311",
    d: "M15985.588,1521.466h-2.154v2.12a.849.849,0,0,1-.849.849h-.118a.849.849,0,0,1-.849-.849v-2.12h-2.155a.849.849,0,0,1-.849-.849h0a.848.848,0,0,1,.849-.848h2.155v-2.122a.849.849,0,0,1,.849-.848h.118a.849.849,0,0,1,.849.848v2.122h2.154a.848.848,0,0,1,.849.848h0A.849.849,0,0,1,15985.588,1521.466Z",
    transform: "translate(-15978.614 -1516.799)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBlu);
export default __webpack_public_path__ + "static/media/plus-blu.b8e234b0dd5de7aa777ab482a1af10ec.svg";
export { ForwardRef as ReactComponent };